import { AxiosResponse } from "axios";
import { api } from "../api";
import { ContentTreeResponse } from "./content-tree.types";

export const getProgramTree = async (
  id: number | string
): Promise<ContentTreeResponse> => {
  try {
    const response: AxiosResponse<ContentTreeResponse> = await api.get(
      `/admin/content/tree/programs/${id}`
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getCourseTree = async (
  id: number | string
): Promise<ContentTreeResponse> => {
  try {
    const response: AxiosResponse<ContentTreeResponse> = await api.get(
      `/admin/content/tree/courses/${id}`
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
